/**
 * Canonical news items that always appear in Studio 13 News
 * (merged ahead of Firestore CMS entries).
 */
function newsImage(file) {
  const base =
    process.env.REACT_APP_MEDIA_BASE?.replace(/\/projects\/?$/, '') ||
    (process.env.NODE_ENV === 'development'
      ? '/img/home-1'
      : '../img/home-1');
  return `${base.replace(/\/$/, '')}/news/${encodeURIComponent(file)}`;
}

export const FEATURED_NEWS = [
  {
    id: 'global-city-dammam-phase-2-development',
    title: 'Phase 2 Development',
    shortDescription: '',
    description: '',
    date: '2026-07-29',
    imageUrl: '',
    link: '',
    comingSoon: true,
  },
  {
    id: 'global-city-dammam-strategic-partnership-award',
    title: 'Global City Dammam — Phase 1 Development',
    shortDescription:
      'Lucamiro Imagineering advances Global City Dammam Phase 1 Development, following the Inaugural Season Strategic Partnership Award.',
    description:
      'Lucamiro Imagineering is advancing Global City Dammam Phase 1 Development.\n\nThis follows the Inaugural Season Strategic Partnership Award presented to Lucamiro Imagineering (Horror House) by Global City Dammam — recognizing exceptional support, dedication, and invaluable contribution behind the scenes to the seamless execution and phenomenal success of the inaugural season.\n\nPresented by: Global City Dammam\nPresented to: Lucamiro Imagineering (Horror House)\nCategory: Strategic Partnership Award — Inaugural Season\n\n“With sincere gratitude for your exceptional support, dedication, and invaluable contribution behind the scenes to the seamless execution and phenomenal success of this season.”',
    date: '2026-07-28',
    imageUrl: newsImage('global-city-dammam-strategic-partnership-award.png'),
    link: '',
  },
];

/** Merge featured local news ahead of CMS items (dedupe by title). */
export function mergeFeaturedNews(cmsItems = []) {
  const cms = Array.isArray(cmsItems) ? cmsItems : [];
  const usedTitles = new Set(
    FEATURED_NEWS.map((n) => String(n.title || '').trim().toLowerCase())
  );

  const rest = cms.filter((n) => {
    const title = String(n.title || '').trim().toLowerCase();
    if (!title) return true;
    if (usedTitles.has(title)) return false;
    usedTitles.add(title);
    return true;
  });

  return [...FEATURED_NEWS, ...rest];
}
